<script setup lang="ts">
const { isOpen, expand, close } = assertInject(DisclosureInjection)
</script>

<template>
  <slot :isOpen="isOpen" :expand="expand" :close="close" />
</template>